"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Alert_1 = require("Views/Shared/Components/Alert/Alert");
const context_1 = require("../context");
const ErrorMessage = () => {
    const { hasError, dictionary: { communicationErrorMessage }, } = (0, context_1.useSearchResultContext)();
    if (!hasError) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(Alert_1.default, { type: "error", message: communicationErrorMessage, hasIcon: false });
};
exports.ErrorMessage = ErrorMessage;
